module.exports = __webpack_public_path__ + "img/analysis-results-update-mobile-fr.2cfd4fcd.jpg";